"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEO_CARDS_POSITIONS = void 0;
var VIDEO_CARDS_POSITIONS;
(function (VIDEO_CARDS_POSITIONS) {
    VIDEO_CARDS_POSITIONS[VIDEO_CARDS_POSITIONS["BOTTOM_LEFT"] = 1] = "BOTTOM_LEFT";
    VIDEO_CARDS_POSITIONS[VIDEO_CARDS_POSITIONS["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
    // TOP_LEFT = 3,
    // TOP_RIGHT = 4,
})(VIDEO_CARDS_POSITIONS = exports.VIDEO_CARDS_POSITIONS || (exports.VIDEO_CARDS_POSITIONS = {}));
//# sourceMappingURL=positions.js.map